export default "__VITE_ASSET__DfKJ9NrC__"